import store from '../store/index'
import thousandDividerFilter from '@/filters/thousand-divider.filter'

export default function currencyFilter(value, format = 'usd') {
  if (format === 'uah') {
    const course = store.getters.getUsdCourse
    return thousandDividerFilter(value * course)
  }
  return thousandDividerFilter(value)
}
